export default __webpack_public_path__ + "static/AMD K5 SSA5 PR100-c468d7b6ea36315ebe2197a1f7701418.jpg";